import { useEffect, useMemo, useState } from 'react'
import { Lookup } from 'src/common/Common.Type'
import DropDown from 'src/component/DropDown'
import Field from 'src/component/field'
import "../style.css"
const DataRow = ({ options, setData, data, index, onDelete
    ,
    decisionId,
    setDecisionId }: any) => {

    const [rowData, setDataRow] = useState()

    const handleChange = (key: string, value: Lookup | null | "") => {
        //@ts-ignore
        setDataRow(prev => ({ ...prev, [key]: value }))
        let tempData = data
        tempData[index][key] = value
        setData([...tempData])
    }

    const handleDelete = () => {
        //@ts-ignore
        let tempData = data.filter((item, itemIndex) => itemIndex != index)
        onDelete(tempData)
        //@ts-ignore
        setDataRow(prev => ({
            hospitalMedicalServiceId: tempData[index]?.hospitalMedicalServiceId,
            notes: tempData[index]?.notes
        }))
    }

    useEffect(() => {
        //@ts-ignore
        setDataRow({ hospitalMedicalServiceId: data[index]?.hospitalMedicalServiceId || null, notes: data[index]?.notes || "" })
    }, [decisionId ,data])

    //@ts-ignore
    const mappedList = useMemo(() => options.map((item, _) => ({ value: item?.id, label: item?.medicalServiceName })), [options])

    return (
        <div className='row row-section '>
            {
                //@ts-ignore
                <DropDown className='col-md-6' placeholder='service-type' label={"service-type"} options={mappedList} val={rowData?.hospitalMedicalServiceId} setVal={(value: Lookup) => handleChange("hospitalMedicalServiceId", value)} />
            }
            {
                //@ts-ignore
                <Field className='col-md-6' placeholder='note' label={'note'} value={rowData?.notes} setValue={val => handleChange("notes", val)} />
            }
            {data?.length != 1 &&

                <div className='delete-icon' onClick={handleDelete}>
                    x
                </div>
            }
        </div>
    )
}

export default DataRow